module.exports = "/assets/data/293de95cc21553a17d8c2cbb2b893d67-SW19.data.json";